export default "__VITE_ASSET__CXqCvgqL__"